import Vue from 'vue';
import VueGtm from 'vue-gtm';
import { MediaQueries } from 'vue-media-queries';
import AOS from 'aos';
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import VueGtag from 'vue-gtag';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';
import store from './store';
import router from './router';
import 'aos/dist/aos.css';
import '@/assets/fonts/fonts.css';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === 'development';

Vue.use(Loading);

const mediaQueries = new MediaQueries();
Vue.use(mediaQueries);
if (!window.PRERENDER_INJECTED) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
      autoHideBadge: true,
      explicitRenderParameters: {
        badge: 'bottomleft',
      },
    },
  });
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GA_CODE_NEW,
      },
      includes: [{ id: process.env.VUE_APP_GA_CODE }],
      onReady() {
        Vue.prototype.$gtagIsLoaded = true;
      },
      onError() {
        Vue.prototype.$gtagIsLoaded = false;
      },
    },
    router
  );
  Vue.use(VueGtm, {
    id: 'GTM-NXVP9FW',
    enabled: true,
    debug: true,
    vueRouter: router,
  });
}

new Vue({
  created() {
    AOS.init({
      duration: 700,
    });
  },
  store,
  router,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
